export default {
  DATASOURCE_ENV: '',
  allowTextFontScaling: false,
  covidEnabled: true
};
